import styled from 'styled-components';

import {colors, breakpoint} from 'theme';

export const SidebarContainer = styled.aside`
    display: none;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: ${colors.white};
    width: 180px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1;
    height: 100vh;
    overflow-y: auto;

    @media (min-width: ${breakpoint.desktop}) {
        display: flex;
    }

    @media print {
        display: none;
    }
`;

export const LogoContainer = styled.div`
    padding-top: 30px;
`;

export const NavContainer = styled.div`
    display: flex;
    flex-flow: column wrap;
    margin: 2rem 0;
    width: 90%;
    flex: 1;
`;
